var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    { attrs: { label: _vm.label } },
    [
      _c(
        "v-select",
        {
          class: { "v-select-danger": _vm.danger, "select-size-sm": _vm.small },
          attrs: {
            name: _vm.name,
            value: _vm.optionSelected,
            options: _vm.paginatedValues,
            disabled: _vm.isDisabled,
            filterable: false,
            clearable: _vm.isClearable,
            placeholder: _vm.placeholder,
            multiple: _vm.isMultiple
          },
          on: {
            search: _vm.onSearch,
            input: _vm.onInput,
            "search:focus": _vm.onFocus
          },
          scopedSlots: _vm._u([
            {
              key: "spinner",
              fn: function() {
                return [
                  _vm.profilesState.loading
                    ? _c("b-spinner", {
                        style: { opacity: _vm.profilesState.loading ? 1 : 0 },
                        attrs: { small: "", variant: "primary" }
                      })
                    : _vm._e()
                ]
              },
              proxy: true
            },
            {
              key: "option",
              fn: function(ref) {
                var value = ref.value
                var label = ref.label
                var iut = ref.iut
                return [
                  _c(
                    "span",
                    {
                      attrs: {
                        "data-cy-iut": iut,
                        "data-cy-value": value,
                        "data-cy-label": label
                      }
                    },
                    [_vm._v(" " + _vm._s(label) + " ")]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "no-options" }, [
            _vm._v(" escribe para buscar perfiles.. ")
          ]),
          _vm.hasNextPage
            ? _c(
                "li",
                {
                  staticClass: "pagination",
                  attrs: { slot: "list-footer" },
                  slot: "list-footer"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-primary btn-sm",
                      attrs: { type: "button", disabled: !_vm.hasNextPage },
                      on: { click: _vm.searchPage }
                    },
                    [_vm._v(" buscar más perfiles... ")]
                  )
                ]
              )
            : _vm._e()
        ],
        2
      ),
      _vm.withFilters ? _c("div", { staticClass: "d-flex mt-1" }) : _vm._e(),
      _vm.danger
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger v-enter-to"
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(_vm._s(_vm.dangerText))
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }